import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/question-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111.1 248 248 0 137-111 248-248 248s-248-111-248-248c0-136.9 111-248 248-248zM256 456c110.6 0 200-89.5 200-200 0-110.5-89.5-200-200-200-110.5 0-200 89.5-200 200 0 110.6 89.5 200 200 200zM363.2 200.8c0 67.1-72.4 68.1-72.4 92.9v6.3c0 6.6-5.4 12-12 12h-45.6c-6.6 0-12-5.4-12-12v-8.7c0-35.7 27.1-50 47.6-61.5 17.6-9.8 28.3-16.5 28.3-29.6 0-17.2-22-28.7-39.8-28.7-23.2 0-33.9 11-48.9 30-4.1 5.1-11.5 6.1-16.7 2.1l-27.8-21.1c-5.1-3.9-6.3-11.1-2.6-16.4 23.6-34.7 53.7-54.2 100.6-54.2 49.1 0 101.5 38.3 101.5 88.8zM298 368c0 23.2-18.8 42-42 42s-42-18.8-42-42 18.8-42 42-42 42 18.8 42 42z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/question-circle.js
// module id = 1809
// module chunks = 0